import { islogin } from "@/api/theApi";

/**
 * 邀请码相关工具函数
 */

// localStorage 中存储邀请码的键名
export const INVITE_CODE_KEY = 'invite_code';

/**
 * 从URL参数中获取邀请码
 * @returns {string|null} 邀请码或null
 */
export function getInviteCodeFromUrl() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams, urlParams.get('invite_code'));
    return urlParams.get('invite_code');
  } catch (error) {
    console.error('获取URL邀请码时发生错误:', error);
    return null;
  }
}

/**
 * 保存邀请码到localStorage
 * @param {string} inviteCode 邀请码
 * @returns {boolean} 是否保存成功
 */
export function saveInviteCode(inviteCode) {
  try {
    if (!inviteCode) {
      console.warn('邀请码为空，无法保存');
      return false;
    }

    localStorage.setItem(INVITE_CODE_KEY, inviteCode);
    console.log('邀请码已保存到localStorage:', inviteCode);
    return true;
  } catch (error) {
    console.error('保存邀请码时发生错误:', error);
    return false;
  }
}

/**
 * 从localStorage获取邀请码
 * @returns {string|null} 邀请码或null
 */
export function getInviteCode() {
  try {
    return localStorage.getItem(INVITE_CODE_KEY);
  } catch (error) {
    console.error('获取邀请码时发生错误:', error);
    return null;
  }
}

/**
 * 清除localStorage中的邀请码
 * @returns {boolean} 是否清除成功
 */
export function clearInviteCode() {
  try {
    localStorage.removeItem(INVITE_CODE_KEY);
    console.log('邀请码已从localStorage中清除');
    return true;
  } catch (error) {
    console.error('清除邀请码时发生错误:', error);
    return false;
  }
}

/**
 * 从URL中移除invite_code参数
 * @returns {boolean} 是否移除成功
 */
export function removeInviteCodeFromUrl() {
  try {
    const url = new URL(window.location);
    url.searchParams.delete('invite_code');

    // 使用pushState更新URL，不会触发页面刷新
    window.history.pushState({}, '', url.toString());
    console.log('已从URL中移除invite_code参数');
    return true;
  } catch (error) {
    console.error('移除URL邀请码参数时发生错误:', error);
    return false;
  }
}

/**
 * 检查并处理URL中的邀请码
 * 如果URL中有invite_code参数，则保存到localStorage并可选择性清理URL
 * @param {boolean} cleanUrl 是否清理URL中的invite_code参数，默认为true
 * @returns {string|null} 找到的邀请码或null
 */
export async function processInviteCodeFromUrl(cleanUrl = true) {
  const inviteCode = getInviteCodeFromUrl();

  if (inviteCode) {
    // 保存邀请码
    const saved = saveInviteCode(inviteCode);
    const loginStatus = await islogin();
    if (loginStatus.login_status) {
      location.replace(`${window.location.origin}${process.env.BASE_URL}user`);
      return inviteCode; // 不要在重定向时返回 null，否则会被控制台误认为没找到邀请码
    }

    if (saved && cleanUrl) {
      // 清理URL参数
      removeInviteCodeFromUrl();
    }

    return inviteCode;
  }

  return null;
}

/**
 * 检查是否有有效的邀请码（URL或localStorage）
 * @returns {string|null} 邀请码或null
 */
export function getValidInviteCode() {
  // 优先从URL获取
  let inviteCode = getInviteCodeFromUrl();

  if (inviteCode) {
    // 如果URL中有邀请码，保存到localStorage
    saveInviteCode(inviteCode);
    return inviteCode;
  }

  // 从localStorage获取
  return getInviteCode();
}

/**
 * 构造带有邀请码的分享URL
 * @param {string} baseUrl 基础URL
 * @param {string} inviteCode 邀请码
 * @returns {string} 带有邀请码的完整URL
 */
export function buildInviteUrl(baseUrl, inviteCode) {
  try {
    if (!baseUrl || !inviteCode) {
      console.warn('构造邀请URL时缺少必要参数');
      return baseUrl || '';
    }

    const url = new URL(baseUrl);
    url.searchParams.set('invite_code', inviteCode);
    return url.toString();
  } catch (error) {
    console.error('构造邀请URL时发生错误:', error);
    return baseUrl || '';
  }
} 
